export default __webpack_public_path__ + "static/decoration-843947cb8e71468377c2a252aba96c1e.svg";